import { styled } from 'baseui';
type ControlStyleT = {
  $width?: string;
  $placement: string;
};
export const TimelineContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  paddingTop: $theme.sizing.scale400
}));
export const SliderWrapper = styled('section', {
  width: '70%'
});
export const Controls = styled<'section', ControlStyleT>('section', ({
  $width,
  $placement
}: ControlStyleT) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: $placement === 'right' ? 'flex-end' : 'flex-start',
  width: $width || 'auto',
  paddingLeft: $placement === 'right' ? '10px' : '0px',
  paddingRight: $placement === 'left' ? '15px' : '0px'
}));
export const Playtime = styled('span', ({
  $theme
}) => ({
  ...$theme.typography.font200,
  fontWeight: '600'
}));